{
  "chart": {
    "empty": {
      "description": "Der er ingen data tilgængelige for denne periode.",
      "title": "Ingen data fundet"
    }
  },
  "date_picker": {
    "all_time": "Altid",
    "confirm": "Bekræft",
    "current_quarter": "Nuværende kvartal",
    "date_range": "{startDate} - {endDate}",
    "last_n_days": "Sidste {days} dage",
    "last_n_months": "Sidste {months} måneder",
    "last_quarter": "Sidste kvartal",
    "last_year": "Sidste år",
    "lifetime": "Hele perioden",
    "this_year": "I år",
    "today": "I dag"
  },
  "document_viewer": {
    "sidebar_heading": "Indholdsoversigt"
  },
  "dynamic_keys": {
    "saml": {
      "providers": {
        "microsoft_scim": "Microsoft Entra ID",
        "okta_scim": "Okta"
      }
    }
  },
  "editor": {
    "placeholder": "Skriv noget",
    "placeholder_with_options": "Skriv eller tast '/' for valgmuligheder"
  },
  "error": {
    "title": "Der skete en fejl."
  },
  "factor_indicator": {
    "average": "Middel",
    "bad": "Kritisk",
    "excellent": "Suverænt",
    "good": "Godt"
  },
  "gauge_chart": {
    "empty": {
      "title": "Ingen data tilgængelig",
      "tooltip": "Din score bliver beregnet"
    }
  },
  "locale": {
    "current": "Dansk",
    "danish": "Dansk",
    "dutch": "Nederlands",
    "english": "English",
    "finnish": "Suomi",
    "french": "Français",
    "german": "Deutsch",
    "norwegian": "Norsk",
    "polish": "Polski",
    "portugese": "Português",
    "spanish": "Español",
    "swedish": "Svenska"
  },
  "saml_provider_button": {
    "continue_with": "Fortsæt med {provider}"
  },
  "search": {
    "no_options": "Ingen tilgængelige muligheder.",
    "no_results": "Ingen resultater fundet.",
    "placeholder": "Søg..."
  },
  "simulations": {
    "expand_preview": {
      "close": "Luk forhåndsvisning",
      "open": "Udvid forhåndsvisning"
    }
  },
  "video_player": {
    "captions": "Undertekster",
    "captions_off": "Fra",
    "normal_speed": "Normal",
    "playback_speed": "Afspilningshastighed"
  }
}
